/** TODO(delivery-api): replace these placeholders with mapped metric data. */
export const CONDITION_METRIC_OPTIONS = [
  {
    value: "revenue",
    label: "Revenue",
    currentMetricText: "Current revenue: $8800",
  },
  {
    value: "weighted-pipeline",
    label: "Weighted pipeline",
    currentMetricText: "Current: $4.8M",
  },
  { value: "orders", label: "Orders", currentMetricText: "Current: 1,240" },
  { value: "profit", label: "Profit", currentMetricText: "Current: $2.1M" },
  { value: "growth", label: "Growth", currentMetricText: "Current: 12.4%" },
] as const;

export const CONDITION_OPERATOR_OPTIONS = [
  { value: "exceeds", label: "exceeds" },
  { value: "falls-below", label: "falls below" },
  { value: "equals", label: "equals" },
] as const;

export type ConditionMetricValue = (typeof CONDITION_METRIC_OPTIONS)[number]["value"];
export type ConditionOperatorValue =
  (typeof CONDITION_OPERATOR_OPTIONS)[number]["value"];

export const CONDITION_METRIC_DROPDOWN_OPTIONS =
  CONDITION_METRIC_OPTIONS.map(({ value, label }) => ({ value, label }));

export const CONDITION_COMPARATOR_DROPDOWN_OPTIONS =
  CONDITION_OPERATOR_OPTIONS.map(({ value, label }) => ({ value, label }));

export const CONDITION_CURRENT_METRIC_TEXT = CONDITION_METRIC_OPTIONS.reduce<
  Record<string, string>
>((texts, option) => {
  texts[option.value] = option.currentMetricText;
  return texts;
}, {});

export const ALERT_CONDITION_HELPER =
  "You'll be notified when this condition is met using the latest data." as const;
